import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  HTML_INLINE_FIGURE_SANDBOX,
  buildPreviewDocument,
  extractHtmlTitle,
  parsePreviewMessage,
} from '../../utils/htmlPreview';
import { trackChatUxEvent } from '../../utils/eventTracker';

const INITIAL_HEIGHT = 320;
const MIN_HEIGHT = 160;
// 그림 하나가 휴대폰 한 화면을 다 덮지 않게. 더 긴 것은 「크게 보기」로 본다.
const MAX_HEIGHT = 560;

const makeToken = () => `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;

const ExpandIcon = () => (
  <svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" />
  </svg>
);

/** 휴대폰 답변 안에 그림 HTML 을 바로 그린다. 격리(sandbox, allow-same-origin 없음)는 오른쪽 미리보기와 같다. */
const InlineHtmlFigure = ({ code, onExpand }) => {
  const iframeRef = useRef(null);
  const [height, setHeight] = useState(INITIAL_HEIGHT);
  const token = useMemo(() => makeToken(), []);
  const srcDoc = useMemo(() => buildPreviewDocument(code, { token }), [code, token]);
  const title = useMemo(() => extractHtmlTitle(code, '그림'), [code]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (!iframeRef.current || event.source !== iframeRef.current.contentWindow) return;
      const parsed = parsePreviewMessage(event.data, token);
      if (!parsed || parsed.type !== 'size' || !parsed.height) return;
      setHeight(Math.min(Math.max(parsed.height, MIN_HEIGHT), MAX_HEIGHT));
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [token]);

  useEffect(() => {
    trackChatUxEvent('html_figure_inline', { entry: 'mobile' });
  }, []);

  return (
    <figure className="em-inline-figure">
      <iframe
        ref={iframeRef}
        className="em-inline-figure-frame"
        title={`${title} 그림`}
        sandbox={HTML_INLINE_FIGURE_SANDBOX}
        referrerPolicy="no-referrer"
        loading="lazy"
        srcDoc={srcDoc}
        style={{ height }}
      />
      <div className="em-inline-figure-tools">
        <button type="button" className="em-inline-figure-expand" onClick={onExpand}>
          <ExpandIcon />
          <span>크게 보기</span>
        </button>
      </div>
    </figure>
  );
};

export default InlineHtmlFigure;
